import React from 'react'
import PropTypes from 'prop-types'
import { TitleToolbar } from './TitleToolbar'
import { useImgAltLogo, useImgSrcLogo } from '../../store'
import { useParams } from 'react-router-dom'

/** displays title to the left as h1 for the page with children
    (buttons, dropdown) to the right in a bar alongside the logo image */
const Toolbar = (props) => {
  const { tenantUrlSlug } = useParams()
  const imgSrcLogo = useImgSrcLogo()
  const imgAltLogo = useImgAltLogo()
  return (
    <TitleToolbar
      collapseOnSelect
      className='title-toolbar'
      variant='dark'
      logoSrc={imgSrcLogo}
      logoAlt={imgAltLogo}
      logoHref={`/${tenantUrlSlug || ''}`}
      {...props}
    />
  )
}

Toolbar.propTypes = {
  /** the text to display as heading */
  title: PropTypes.string.isRequired,
  /** other items shown in the toolbar */
  children: PropTypes.node
}

export { Toolbar }
